import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
const url = environment.url;
@Injectable({
  providedIn: 'root',
})
export class HistoricosService {
  constructor(private http: HttpClient) {}

  removeNulls(obj) {
    return Object.fromEntries(
      Object.entries(obj.params).filter(([, value]) => value !== null && value !== undefined && value !== '')
    );
  }

  async getHistoricosData(params) {
    const filteredParams = this.removeNulls(params);
    // const newParams = {
    //   fecha_inicio: '2024-12-01',
    //   fecha_fin: '2025-12-03',
    //   peticion: 'cedidos',
    //   num_pagina: '34',
    //   JOBCODE: 'JOB21249',
    //   ORGCODE: 'ORG17487',
    // };
    return new Promise((resolve) => {
      this.http
        .post(`${url}/api/aurora/protocolos`, { params: filteredParams }, { withCredentials: true })
        .subscribe((resp) => {
          resolve(resp);
        });
    });
  }

  async getFilters(params) {
    const filteredParams = this.removeNulls(params);
    filteredParams.filter = 'grafico';
    filteredParams.JOBCODE = JSON.parse(localStorage.getItem('userData')!).roleCode;
    return new Promise((resolve) => {
      this.http.post(`${url}/api/aurora/filtros`, filteredParams, { withCredentials: true }).subscribe((resp) => {
        resolve(resp);
      });
    });
  }
}
